import type React from 'react';
import { Avatar } from 'antd';
import userImg from 'assets/images/user.png';

interface UserInfoProps {
  name: string;
  avatarUrl?: string;
}

const UserInfo: React.FC<UserInfoProps> = ({ name, avatarUrl }) => (
  <div className="flex gap-2 items-center">
    <Avatar src={avatarUrl || userImg} size={30} />
    <p className="text-[16px]">{name}</p>
  </div>
);

export default UserInfo;
